import script from "./details.vue?vue&type=script&setup=true&lang=js"
export * from "./details.vue?vue&type=script&setup=true&lang=js"

import "./details.vue?vue&type=style&index=0&id=31ea21f6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ea21f6"]])

export default __exports__